/*  ========================================================================
    # Components - EventSubmission
    ========================================================================  */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useLocalization from '../../hooks/useLocalization';
import EventEntry from './EventEntry';
import bem from '../../utils/bem';
import useEventStore from '../../stores/events';
import useGetParams from '../../hooks/useGetParams';
import useTranslation from '../../hooks/useTranslation';

const EventSubmission = ({ events }) => {
  const local = useLocalization();
  const getParams = useGetParams();
  const __ = useTranslation();
  const [showOthers, setShowOthers] = useState(false);
  const { selectedDates } = useEventStore();
  const fieldClass = '.enoplan-event-input';

  const getFieldString = date => {
    const dateSplit = date.split('-');
    const postID = Number(dateSplit[0]);
    const dateString = new Date(dateSplit[1]).toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
    let event;
    let postTitle = '';

    if (events.current.id === postID) {
      postTitle = events.current.title;
      event = events.current;
    } else {
      events.events.forEach(el => {
        if (el.id === postID) {
          postTitle = el.title;
          event = el;
        }
      });
    }

    const selectedDate = event.dates.find(el => el['date'] === dateSplit[1]);
    const timeString = `${selectedDate['start_time'] ? selectedDate['start_time'] : ''}${selectedDate['end_time'] ? ' - ' + selectedDate['end_time'] : ''}`;
    const fieldString = '- ' + postTitle + ', ' + dateString + ' ' + timeString + ' </br>';

    return fieldString;
  };

  useEffect(() => {
    let fieldValue = '';
    selectedDates.forEach(date => {
      fieldValue += getFieldString(date);
    });

    // Add selectedDates to ninja form field
    jQuery(fieldClass).val(fieldValue).trigger('change');
  }, [selectedDates]);

  useEffect(() => {
    const paramDates = getParams['selectedDates'] ? getParams['selectedDates'].split(',') : null;

    if (paramDates) {
      let fieldValue = '';
      paramDates.forEach(date => {
        fieldValue += getFieldString(date);
      });

      // Add selectedDates to ninja form field
      jQuery(document).on('nfFormReady', () => {
        jQuery(fieldClass).val(fieldValue).trigger('change');
      });
    }
  }, []);

  return (
    <div className='s-event-submission__events'>
      <EventEntry
        eventId={events['current']['id']}
        type={events['current']['type']}
        isOnline={events['current']['is_online']}
        location={events['current']['location']}
        title={events['current']['title']}
        dates={events['current']['dates']}
        people={events['current']['people']}
        initalOpen={true}
        isClosable={false}
      />
      {events['events'].length > 0 ? (
        <>
          <button
            type='button'
            className={bem('s-event-submission', 'others-trigger', { active: showOthers })}
            onClick={() => setShowOthers(!showOthers)}
          >
            {__('event-form-error-message')}
            <div className='c-button c-button--icon c-button--icon-light'>
              <svg viewBox='0 0 24 24'>
                <use href={`${local('svgSprite')}#angle-down`} />
              </svg>
            </div>
          </button>
          <div className={bem('s-event-submission', 'others', { active: showOthers })}>
            <div className='s-event-submission__others-wrapper'>
              {events['events'].map((event, index) => (
                <EventEntry
                  key={index}
                  eventId={event['id']}
                  type={event['type']}
                  isOnline={event['is_online']}
                  location={event['location']}
                  title={event['title']}
                  dates={event['dates']}
                  initalOpen={false}
                  people={event['people']}
                />
              ))}
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
};

EventSubmission.propTypes = {
  events: PropTypes.object
};

export default EventSubmission;
